import { pascalCase } from 'change-case';
import { capitalizeSentence } from 'common/humanizeValues';
import moment from 'moment';

export function humanizeDateRange(startDate: string, endDate: string | undefined) {
  return `${moment(startDate).format('MMM YYYY')} - ${endDate ? moment(endDate).format('MMM YYYY') : 'Present'}`;
}

export function humanizeDegree(degree: string, fieldOfStudy: string | undefined) {
  return capitalizeSentence(degree) + (fieldOfStudy ? ` in ${fieldOfStudy}` : '');
}
